import axios from "@/utils/request";

export const getWebSiteInfo = () => {
  return axios.post(`${process.env.VUE_APP_BASE_URL}/store/webPage`);
};

export const getActivityList = () => {
  return axios.post(`${process.env.VUE_APP_BASE_URL}//activity/webActivityList`, { type: 1 });
};
